// extracted by mini-css-extract-plugin
module.exports = {"error":"errorPage_error__IZm6B","code":"errorPage_code__8Cazo","wrapper":"errorPage_wrapper__27LZ3","message":"errorPage_message__eTWen"};